/*
 * @Author: Tarzan
 * @Date: 2021-08-09 10:46:11
 * @LastEditTime: 2021-08-11 14:51:23
 * @LastEditors: Tarzan
 * @Description:
 * @FilePath: \jyedit-managed:\0job\project\jyedit-pc\src\api\goodsCart.js
 */
import request from '@/utils/request'
/**
 * 获取购物车商品列表
 */
export function goodsCartList() {
	return request({
		url: '/member/wap/goods/goodsCart',
		method: 'post',
		data:{}
	})
}
export function fullGift(params) {
	return request({
		url: '/member/wap/order/fullGift',
		method: 'get',
        params
	})
}
export function saveFullGift(data) {
	return request({
		url: 'member/wap/order/saveFullGift',
		method: 'post',
		data
	})
}
/**
 * 删除选中
 */
export function deleteSelect(data) {
	return request({
		url: '/member/wap/goods/deleteGoodsCart',
		method: 'post',
		data
	})
}
/**
 *去结算
 */
export function createTempOrder(data) {
	return request({
		url: 'member/wap/goods/createTempOrder',
		method: 'post',
		data
	})
}

//购物车中为你推荐
export function likeGoods() {
	return request({
		url: 'wap/home/cnxh',
		method: 'get'
	})
}

//修改商品数量
export function changeCounts(data){
	return request({
		url: 'member/wap/goods/goodsCart/changeCounts',
		method: 'put',
		data
	})
}

//购物车商品总数量
export function goodsCartCountsTotal(){
	return request({
		url: 'member/wap/goods/goodsCart/counts',
		method: 'get'
	});
}

// 配赠余额
export function checkMoney(params){
	return request({
		url: 'member/wap/gift/goods/check_money',
		method: 'get',
		params
	});
}
//按客户类型获取下单配赠额度限制
export function getRemainderDecimal(){
	return request({
		url: 'member/wap/gift/goods/getRemainderDecimal',
		method: 'get'
	});
}
